<template>
    <div>
        <div class="user-profile-page-container mt-5">
            <div class="account-header">
                <span class="account-setting locale-font">
                    {{ $vuetify.lang.t('$vuetify.userProfile.accountSetting') }}
                </span>
                <div>
                    <v-btn
                    @click="back()"
                    outlined
                    class="mr-4"
                    width="150"
                    color="primary">
                        {{ $vuetify.lang.t('$vuetify.userProfile.cancel') }}
                    </v-btn>

                    <v-btn
                        @click="submit()"
                        width="150"
                        color="primary">
                        {{ $vuetify.lang.t('$vuetify.userProfile.save') }}
                    </v-btn>
                </div>
            </div>
            <v-card class="mt-4">
                <div class="profile-container">
                    <span class="profile locale-font">
                        {{ $vuetify.lang.t('$vuetify.userProfile.profile') }}
                    </span>
                    <v-form
                            ref="form"
                            v-model="valid"
                            lazy-validation>
                        <v-row>
                            <v-col cols="3">
                                <div class="profile-picture-container">
                                    <profile
                                        :isEditing="true"
                                        @change-profile-img="changeProfileImg"
                                        :img="form.image"/>
                                </div>
                            </v-col>
                            <v-col cols="9">
                                <v-row>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="form.firstName"
                                            :label="$vuetify.lang.t('$vuetify.userProfile.name')"
                                            autocomplete="off"
                                            placeholder=" "
                                            :rules="inputRules"
                                            :error-messages="errors.firstName">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="form.lastName"
                                            :label="$vuetify.lang.t('$vuetify.userProfile.surname')"
                                            autocomplete="off"
                                            placeholder=" "
                                            :rules="inputRules"
                                            :error-messages="errors.lastName">
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="form.email"
                                            :label="$vuetify.lang.t('$vuetify.userProfile.email')"
                                            autocomplete="off"
                                            placeholder=" "
                                            :rules="inputRules"
                                            :error-messages="errors.email">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="phoneNumberMask"
                                            :prefix="`(${prefixPhone})`"
                                            v-mask = "'## ### ####'"
                                            :label="$vuetify.lang.t('$vuetify.userProfile.phoneNumber')"
                                            autocomplete="off"
                                            placeholder=" "
                                            :rules="inputRules">
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="role"
                                            :label="$vuetify.lang.t('$vuetify.userProfile.role')"
                                            placeholder=" "
                                            readonly>
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                                <span
                                    @click="toggleResetPassword()"
                                    class="reset-pass">
                                    {{ $vuetify.lang.t('$vuetify.userProfile.resetPassword') }}

                                    <i v-if="form.isResettingPassword" class="ml-3 fas fa-chevron-down"></i>
                                    <i v-else class="ml-3 fas fa-chevron-up"></i>
                                </span>
                                <v-row v-if="form.isResettingPassword">
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="form.currentPassword"
                                            :label="$vuetify.lang.t('$vuetify.userProfile.currentPassword')"
                                            :placeholder="$vuetify.lang.t('$vuetify.userProfile.placeholderCurrentPassword')"
                                            :rules="currentPasswordRules"
                                            :error-messages="errors.currentPassword"
                                            type="password">
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row v-if="form.isResettingPassword">
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="form.newPassword"
                                            :label="$vuetify.lang.t('$vuetify.userProfile.newPassword')"
                                            :placeholder="$vuetify.lang.t('$vuetify.userProfile.placeholderNewPassword')"
                                            :rules="newPasswordRules"
                                            :error-messages="errors.newPassword"
                                            type="password">
                                        </v-text-field>
                                    </v-col>
                                    <v-col cols="6">
                                        <v-text-field
                                            v-model="form.confirmPassword"
                                            :label="$vuetify.lang.t('$vuetify.userProfile.confirmPassword')"
                                            :placeholder="$vuetify.lang.t('$vuetify.userProfile.placeholderConfirmPassword')"
                                            :rules="confirmPasswordRules"
                                            :error-messages="errors.confirmPassword"
                                            type="password">
                                        </v-text-field>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-form>
                </div>
            </v-card>
        </div>
    </div>
</template>

<script>
import { mask } from 'vue-the-mask'
import profileDefault from '@/assets/user_default.png'
import Profile from '@/components/Profile'
export default {
    name: 'UserProfile',

    components: {
        Profile
    },

    directives: {
        mask
    },
    computed: {
        inputRules () {
            return [
                v => !!v || this.$vuetify.lang.t('$vuetify.userProfile.userprofileIsUpdated')
            ]
        },
        msgUpdateSuccess () {
            return {
                title: this.$vuetify.lang.t('$vuetify.userProfile.congratulation'),
                text: this.$vuetify.lang.t('$vuetify.userProfile.userprofileIsUpdated'),
                type: 'success'
            }
        }
    },
    data () {
        return {
            form: {
                image: '',
                firstName: '',
                lastName: '',
                email: '',
                isResettingPassword: false,
                currentPassword: '',
                newPassword: '',
                confirmPassword: ''
            },
            role: '',
            prefixPhone: '+66',
            phoneNumberMask: '',
            errors: this.getDefaultErrors(),
            prevImg: '',
            valid: true,
            currentPasswordRules: [
                v => !!v || 'Current password is required'
            ],
            newPasswordRules: [
                v => !!v || 'New password is required'
            ],
            confirmPasswordRules: [
                v => !!v || 'Confirm password is required',
                v => this.form.newPassword === this.form.confirmPassword || 'Confirm password should be same'
            ]
        }
    },

    methods: {
        async getUserProfile () {
            this.$store.dispatch('setLoading', true)

            const res = await this.axios.get('user/user-profile')

            if (res && res.data && res.data.status === 'ok') {
                const response = res.data.data
                this.form.firstName = response.first_name
                this.form.lastName = response.last_name
                this.phoneNumberMask = response.userProfile.phone_number.slice(4)
                this.form.email = response.email
                this.role = response.roleName
                // set default image for empty f_path
                if (!response.userImage) {
                    this.form.image = profileDefault
                    this.prevImg = profileDefault
                } else {
                    this.form.image = response.userImage
                    this.prevImg = response.userImage
                }

                this.$store.dispatch('setLoading', false)
            }
        },

        changeProfileImg (event) {
            const fileList = event.target.files

            const reader = new FileReader()
            let imgBase64 = null

            if (fileList[0]) {
                reader.onload = () => {
                    imgBase64 = reader.result
                    this.form.image = imgBase64
                }

                reader.readAsDataURL(fileList[0])
            }
        },

        back () {
            this.$router.back()
        },

        async submit () {
            if (!this.$refs.form.validate()) {
                return
            }

            await this.updateUserProfile()
        },

        toggleResetPassword () {
            this.form.isResettingPassword = !this.form.isResettingPassword
        },

        getDefaultErrors () {
            return {
                firstName: null,
                lastName: null,
                email: null,
                currentPassword: null,
                newPassword: null,
                confirmPassword: null
            }
        },

        async updateUserProfile () {
            this.$store.dispatch('setLoading', true)

            const form = {
                first_name: this.form.firstName,
                last_name: this.form.lastName,
                email: this.form.email,
                phone_number: `${this.prefixPhone} ${this.phoneNumberMask}`,
                isResettingPassword: this.form.isResettingPassword,
                currentPassword: this.form.currentPassword,
                newPassword: this.form.newPassword,
                confirmPassword: this.form.confirmPassword
            }

            if (this.prevImg !== this.form.image) {
                form.image = this.form.image
            }

            const userId = localStorage.getItem('userId')

            const res = await this.axios.put(`user/edit/by-user/${userId}`, form)

            if (res && res.data && res.data.status === 'ok') {
                await this.$store.dispatch('getUserProfile')
                await this.getUserProfile()

                this.$store.dispatch('setLoading', false)

                this.form.isResettingPassword = false
                this.form.currentPassword = ''
                this.form.newPassword = ''
                this.form.confirmPassword = ''

                this.errors = this.getDefaultErrors()

                this.$notify(this.msgUpdateSuccess)
            } else if (res && res.data && res.data.status === 'error_inputs') {
                this.errors = res.data.errors
                this.$store.dispatch('setLoading', false)
            }
        }
    },

    async mounted () {
        await this.getUserProfile()
    }
}
</script>

<style lang="scss" scoped>
.user-profile-page-container {
    margin: 0rem 16.5rem;
}
.account-setting {
    font-size: 32px;
    color: #131410;
}
.account-header {
    display: flex;
    justify-content: space-between;
}
.profile {
    font-size: 24px;
}
.profile-container {
    padding: 2.25rem;
}
.profile-picture-container {
    display: flex;
    justify-content: center;
}
.reset-pass {
    font-family: 'LexendDeca';
    font-size: 18px;
    color: #d76436;
    cursor: pointer;
    text-decoration: underline;
}
</style>
